<nav mat-tab-nav-bar>
  @for (graphLink of graphLinks; track graphLink) {
    <button mat-tab-link
      [routerLink]="graphLink.url"
      routerLinkActive="mdc-tab--active"
      [active]="isRouteActive(graphLink.url)"
      appAriaTitle>
      {{graphLink.label | translate}}
    </button>
  }
</nav>